module.exports = __webpack_public_path__ + "img/memperbaiki-skor-kredit.d01e5966.svg";